/* eslint-disable no-undef */
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { styled, useTheme } from '@mui/material/styles';
import { Box, Stack, Drawer } from '@mui/material';

// hooks
import useResponsive from '../../../hooks/useResponsive';
import useCollapseDrawer from '../../../hooks/useCollapseDrawer';
// utils
import cssStyles from '../../../utils/cssStyles';
// config
import { NAVBAR } from '../../../config';
// components
import Logo from '../../../components/Logo';
import Scrollbar from '../../../components/Scrollbar';
import { NavSectionVertical } from '../../../components/nav-section';

//
// import navConfig from './NavConfig';
import NavbarDocs from './NavbarDocs';
import NavbarAccount from './NavbarAccount';
import CollapseButton from './CollapseButton';
import { PATH_DASHBOARD } from '../../../routes/paths';

// components

import SvgIconStyle from '../../../components/SvgIconStyle';
// import Navbuton from '../../../components/Navbuton';

const getIcon = (name) => <SvgIconStyle src={`/logo/${name}.png`} sx={{ width: 1, height: 1 }} />;
const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  booking: getIcon('ic_booking'),
  video:getIcon('ic_video'),
  coachreview:getIcon('ic_coachreview'),
  videoreview:getIcon('ic_videoreview:'),
  audioreview:getIcon('ic_audioreview')

};

const userid = window.localStorage.getItem('user_id');
console.log(userid);

// ----------------------------------------------------------------------

const navConfig = [
  {
    subheader: 'author',
    items: [
      { title: 'dashboard', path: PATH_DASHBOARD.general.app, icon: ICONS.dashboard },
      { title: 'author', path: PATH_DASHBOARD.general.author, icon: ICONS.user },
      { title: 'book', path: PATH_DASHBOARD.general.book, icon: ICONS.booking },
      { title: 'book Review', path: PATH_DASHBOARD.general.bookreview, icon: ICONS.blog },
      { title: 'author review', path: PATH_DASHBOARD.general.authorreview, icon: ICONS.analytics },
      // { title: 'analytics', path: PATH_DASHBOARD.general.analytics, icon: ICONS.analytics },
    ],
  },
];

const navConfig1 = [
  {
    subheader: 'coach',
    items: [
      { title: 'dashboard', path: PATH_DASHBOARD.general.app, icon: ICONS.dashboard },
      { title: 'coach', path: PATH_DASHBOARD.general.coach, icon: ICONS.calendar },
      { title: 'audio', path: PATH_DASHBOARD.general.audio, icon: ICONS.ecommerce },
      { title: 'video', path: PATH_DASHBOARD.general.video, icon: ICONS.video },
      { title: 'coach review', path: PATH_DASHBOARD.general.coachreview, icon: ICONS.coachreview },
      { title: 'audio review', path: PATH_DASHBOARD.general.audioreview, icon: ICONS.audioreview },
      { title: 'video review', path: PATH_DASHBOARD.general.videoreview, icon: ICONS.kanban },
    ],
  },
];
const navConfig2 = [
  {
    subheader: 'coach',
    items: [
      { title: 'dashboard', path: PATH_DASHBOARD.general.app, icon: ICONS.dashboard },
      { title: 'coach', path: PATH_DASHBOARD.general.coach, icon: ICONS.calendar },
      { title: 'audio', path: PATH_DASHBOARD.general.audio, icon: ICONS.ecommerce },
      { title: 'video', path: PATH_DASHBOARD.general.video, icon: ICONS.video },
      { title: 'coach review', path: PATH_DASHBOARD.general.coachreview, icon: ICONS.coachreview },
      { title: 'audio review', path: PATH_DASHBOARD.general.audioreview, icon: ICONS.audioreview },
      { title: 'video review', path: PATH_DASHBOARD.general.videoreview, icon: ICONS.kanban },
    ],
  },
  {
    subheader: 'author',
    items: [
       
      { title: 'author', path: PATH_DASHBOARD.general.author, icon: ICONS.user },
      { title: 'book', path: PATH_DASHBOARD.general.book, icon: ICONS.booking },
      { title: 'book Review', path: PATH_DASHBOARD.general.bookreview, icon: ICONS.blog },
      { title: 'author review', path: PATH_DASHBOARD.general.authorreview, icon: ICONS.analytics },
    ],
  },
];

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
   
    transition: theme.transitions.create('width', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

// ----------------------------------------------------------------------

NavbarVertical.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
 
};

export default function NavbarVertical({ isOpenSidebar, onCloseSidebar }) {
  const theme = useTheme();

  const { pathname } = useLocation();

  const isDesktop = useResponsive('up', 'lg');

  const { isCollapse, collapseClick, collapseHover, onToggleCollapse, onHoverEnter, onHoverLeave } =
    useCollapseDrawer();

  const [usertype, setUserType] = useState(window.localStorage.getItem('user_type'));
 

  useEffect(() => {
    setUserType(window.localStorage.getItem('user_type'));
  
    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const addNew = () => {

    if (usertype === '2') {
      return navConfig;
    }
    if (usertype === '3') {
      return navConfig1;
    }
    return navConfig2;
  };

  const renderContent = (
    <Scrollbar
  
      offsetbottom={10}
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
      }}
    >
      <Stack 
        spacing={3}
        sx={{
          pt: 3,
          pb: 2,
          px: 2.5,
          flexShrink: 0,
          ...(isCollapse && { alignItems: 'center' }),
        }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Logo />

          {isDesktop && !isCollapse && (
            <CollapseButton onToggleCollapse={onToggleCollapse} collapseClick={collapseClick} />
          )}
        </Stack>

        <NavbarAccount isCollapse={isCollapse} />
      </Stack>
      {/* navConfig={usertype === "2" ? navConfig : navConfig1} */}
      <NavSectionVertical navConfig={addNew()} isCollapse={isCollapse} />

      <Box sx={{ flexGrow: 1 }} />

      {!isCollapse && <NavbarDocs />}
    </Scrollbar>
  );

  return (
    <RootStyle
      sx={{
        width: {
          lg: isCollapse ? NAVBAR.DASHBOARD_COLLAPSE_WIDTH : NAVBAR.DASHBOARD_WIDTH,
        },
        ...(collapseClick && {
          position: 'absolute',
        }),
      }}
    >
      {!isDesktop && (
        <Drawer open={isOpenSidebar} onClose={onCloseSidebar} PaperProps={{ sx: { width: NAVBAR.DASHBOARD_WIDTH } }}>
          {renderContent}
        </Drawer>
      )}

      {isDesktop && (
        <Drawer
          open
          variant="persistent"
          onMouseEnter={onHoverEnter}
          onMouseLeave={onHoverLeave}
          PaperProps={{
            sx: {
              width: NAVBAR.DASHBOARD_WIDTH,
              // borderRightStyle: '1px solid #fefefe',
              // bgcolor: 'background.default',
              // zIndex: '1',
              // position: 'inherit',

              transition: (theme) =>
                theme.transitions.create('width', {
                  duration: theme.transitions.duration.standard,
                }),
              ...(isCollapse && {
                width: NAVBAR.DASHBOARD_COLLAPSE_WIDTH,
              }),
              ...(collapseHover && {
                ...cssStyles(theme).bgBlur(),
                boxShadow: (theme) => theme.customShadows.z24,
              }),
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </RootStyle>
  );
}
